module.exports = __webpack_public_path__ + "img/maxpro-X.a0c6bcb7.jpg";